(function () {
  const appScriptUrl = "/apps/renk-grubu/pc.js?v=2";
  let observerStarted = false;
  let scanTimer = null;

  function hasSwatchContainers() {
    return Boolean(document.querySelector(".csga-pc"));
  }

  function scheduleScan() {
    if (!window.CSGA || !window.CSGA.PC || !window.CSGA.PC.scan) return;

    clearTimeout(scanTimer);
    scanTimer = setTimeout(window.CSGA.PC.scan, 80);
  }

  function loadAppBundle() {
    if (!hasSwatchContainers()) return;

    if (window.__csgaPCLoad) {
      scheduleScan();
      return;
    }

    window.__csgaPCLoad = 1;

    const script = document.createElement("script");
    script.src = appScriptUrl;
    script.async = true;
    script.addEventListener("load", scheduleScan, { once: true });
    (document.head || document.documentElement).appendChild(script);
  }

  /**
   * MutationObserver'i mumkun oldugunca dar bir agaca bagla.
   *
   * Onceki surum document.documentElement'i subtree:true ile izliyordu; sonsuz
   * kaydirmada her "daha fazla yukle" yuzlerce mutation kaydi uretip callback'i
   * tum sayfa uzerinde calistiriyordu. Ustelik ayni yukleme icin hem bu observer
   * hem de "ahel:dynamic-load" event'i tetikleniyor, yani is iki kere yapiliyordu.
   * Grid konteynerleri varsa sadece onlari izlemek ayni sonucu cok daha ucuza verir;
   * grid yoksa (urun sayfasi, cekmeceler vb.) eski davranisa duseriz.
   */
  function getObserverTargets() {
    const targets = [
      document.querySelector("#ProductGridContainer"),
      document.querySelector("#CollectionGridContainer"),
      document.querySelector("#ArticleGridContainer")
    ].filter(Boolean);

    return targets.length ? targets : [document.documentElement];
  }

  function startObserver() {
    if (observerStarted || !document.documentElement) return;
    observerStarted = true;

    const observer = new MutationObserver((mutations) => {
      const hasNewSwatches = mutations.some((mutation) =>
        Array.from(mutation.addedNodes).some((node) => {
          if (!(node instanceof Element)) return false;
          return node.matches(".csga-pc") || Boolean(node.querySelector(".csga-pc"));
        })
      );

      if (hasNewSwatches) {
        loadAppBundle();
      }
    });

    getObserverTargets().forEach((target) => {
      observer.observe(target, { childList: true, subtree: true });
    });
  }

  function init() {
    loadAppBundle();
    startObserver();
  }

  document.addEventListener("ahel:dynamic-load", loadAppBundle);

  // startObserver'i DOM hazir olana kadar bekletiyoruz; aksi halde grid
  // konteynerleri henuz yokken documentElement'e geri dusuyorduk.
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
    loadAppBundle();
  } else {
    init();
  }
})();
